import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=0bb88d70&scoped=true&"
import script from "./Workplace.vue?vue&type=script&lang=js&"
export * from "./Workplace.vue?vue&type=script&lang=js&"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=0bb88d70&lang=scss&scoped=true&"
import style1 from "./Workplace.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb88d70",
  null
  
)

export default component.exports